export const SALES_DOCUMENT_TYPES = [
  { id: '01', label: 'Invoice' },
  { id: '02', label: 'Credit Note' },
  { id: '03', label: 'Debit Note' },
  { id: '04', label: 'Refund' },
];

export const PURCHASE_DOCUMENT_TYPES = [
  { id: '11', label: 'Self Billed Invoice' },
  { id: '12', label: 'Self Billed Credit Note' },
  { id: '13', label: 'Self Billed Debit Note' },
  { id: '14', label: 'Self Billed Refund' },
];
